import { render, staticRenderFns } from "./delivery.vue?vue&type=template&id=f64e9b78&scoped=true"
import script from "./delivery.vue?vue&type=script&lang=js"
export * from "./delivery.vue?vue&type=script&lang=js"
import style0 from "./delivery.vue?vue&type=style&index=0&id=f64e9b78&scoped=true&lang=css"
import style1 from "./delivery.vue?vue&type=style&index=1&id=f64e9b78&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f64e9b78",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\gitee\\fcops_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f64e9b78')) {
      api.createRecord('f64e9b78', component.options)
    } else {
      api.reload('f64e9b78', component.options)
    }
    module.hot.accept("./delivery.vue?vue&type=template&id=f64e9b78&scoped=true", function () {
      api.rerender('f64e9b78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workOrder/server/delivery.vue"
export default component.exports